import _typeof from "@babel/runtime/helpers/typeof";
/**
 * Утилита для получения сообщения из неизвестной ошибки. Если была получена не ошибка, то вернет undefined.
 *
 * @example
 * attemptToGetMessageFromUnknownError('Some error'); // undefined
 * attemptToGetMessageFromUnknownError(new Error('Some error')); // 'Some error'
 * // Поддерживаются ошибки из `@cian/peperrors`
 * attemptToGetMessageFromUnknownError(new HttpBadStatusCodeError({ message: 'Some error' })); // 'Some error'
 */
export function attemptToGetMessageFromUnknownError(value) {
  if (_typeof(value) === 'object' && value && 'message' in value && typeof value.message === 'string') {
    return value.message;
  }
  return undefined;
}